function initNeedsClick() {
  $('select.needsclick').each(function callback() {
    const thisElement = $(this);
    const form = thisElement.parents('form');
    thisElement.change(() => {
      form[0].submit();
    });
  });
}

module.exports = initNeedsClick;
